import { CitiesGridView } from '~/components/system/cities';
import { PageContainer } from '~/components/page-container';

export function Cities() {
	return (
		<PageContainer>
			<CitiesGridView />
		</PageContainer>
	);
}
